import clsx from 'clsx'

import classes from './index.module.scss'

export const SunburstChartLoading = () => (
  <svg
    className={clsx(classes.chartSkeleton, 'pulse')}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="50" r="50" />
  </svg>
)
